/**
 * UI theme local storage key
 */
export const THEME_STORAGE_KEY = 'theme';

/**
 * UI dark theme local storage key
 */
export const UI_IS_DARK_THEME_KEY = 'uiIsDarkThemeKey';

/**
 * UI OrgTree orientation key
 */
export const UI_ORG_TREE_ORIENTATION_KEY = 'uiOrgTreeOrientationKey';

/**
 * quests_in_progress local storage key
 */
export const QUESTS_IN_PROGRESS_STORAGE_KEY = 'quests_in_progress';

/**
 * quests_in_review local storage key
 */
export const QUESTS_IN_REVIEW_STORAGE_KEY = 'quests_in_review';

/**
 * quests_completed local storage key
 */
export const QUESTS_COMPLETED_STORAGE_KEY = 'quests_completed';

/**
 * quests_rejected local storage key
 */
export const QUESTS_REJECTED_STORAGE_KEY = 'quests_rejected';

/**
 * quests_canceled local storage key
 */
export const QUESTS_CANCELED_STORAGE_KEY = 'quests_canceled';

/**
 * shop_location local storage key
 */
export const SHOP_LOCATION_STORAGE_KEY = 'shop_location';

/**
 * coins_balance local storage key
 */
export const COINS_BALANCE_STORAGE_KEY = 'coins_balance';

/**
 * news page_category and page_subcategory local storage key
 */
export const PAGE_CATEGORY_STORAGE_KEY = 'page_category';
export const PAGE_SUBCATEGORY_STORAGE_KEY = 'page_subcategory';
/**
 * vacation planner current month local storage key
 */
export const VACATION_PLANNER_CURRENT_MONTH_STORAGE_KEY
  = 'vacation_planner_current_month_storage_key';
/**
 * education library page local storage key
 */
export const PAGE_EDUCATION_LIBRARY_POLICY_STORAGE_KEY = 'page_education_library_policy';
/**
 * floating button location storage key - to pass office location to floating button repo
 */
export const FLOATING_BUTTON_LOCATION_STORAGE_KEY = 'fb_office_location_original';
/**
 * floating button is twu user storage key - to pass is twu user to floating button repo
 */
export const FLOATING_IS_TWU_USER_STORAGE_KEY = 'fb_is_twu_user';
